import { render, staticRenderFns } from "./NodeContentPreview.vue?vue&type=template&id=5c5eaf56&scoped=true"
import script from "./NodeContentPreview.vue?vue&type=script&lang=js"
export * from "./NodeContentPreview.vue?vue&type=script&lang=js"
import style0 from "./NodeContentPreview.vue?vue&type=style&index=0&id=5c5eaf56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5eaf56",
  null
  
)

export default component.exports